export default "__VITE_ASSET__DYdVTGum__"